import { motion } from "framer-motion";
function Preloader() {
  return (
    <div className="h-screen grid place-items-center">
      <svg
        width="64"
        height="76"
        viewBox="0 0 27 39"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <motion.rect
          initial={{ x: 0, width: 9 }}
          animate={{
            width: 11,
            x: 5,
            transition: {
              yoyo: Infinity,

              duration: 0.4,
              ease: "easeOut",
            },
          }}
          x="9"
          y="26"
          width="11"
          height="5"
          fill="#00FFC2"
        />
        <path
          d="M1.76136 31V7.72727H11.375C13.1174 7.72727 14.6212 8.06818 15.8864 8.75C17.1591 9.42424 18.1402 10.3674 18.8295 11.5795C19.5189 12.7841 19.8636 14.1856 19.8636 15.7841C19.8636 17.3902 19.5114 18.7955 18.8068 20C18.1098 21.197 17.1136 22.125 15.8182 22.7841C14.5227 23.4432 12.9848 23.7727 11.2045 23.7727H5.27273V19.3409H10.1591C11.0076 19.3409 11.7159 19.1932 12.2841 18.8977C12.8598 18.6023 13.2955 18.1894 13.5909 17.6591C13.8864 17.1212 14.0341 16.4962 14.0341 15.7841C14.0341 15.0644 13.8864 14.4432 13.5909 13.9205C13.2955 13.3902 12.8598 12.9811 12.2841 12.6932C11.7083 12.4053 11 12.2614 10.1591 12.2614H7.38636V31H1.76136Z"
          fill="#D8DCE9"
        />
      </svg>
    </div>
  );
}

export default Preloader;
